export default function FlameIcon(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.2503 9.75C14.2503 9.75 15.2253 3.99825 11.2503 1.5C11.1923 2.48804 10.9269 3.45279 10.4714 4.33148C10.0159 5.21018 9.38049 5.98311 8.60652 6.6C6.90852 8.1 3.71652 11.463 3.75027 15.06C3.77802 17.9662 5.35901 21.5212 9.00852 22.785C9.00327 22.71 9.00027 22.635 9.00027 22.56C9.0382 21.225 9.55672 19.9485 10.4605 18.9653C11.2113 18.2199 11.6723 17.2317 11.761 16.1775C13.9083 17.373 15.0003 20.5275 15.0003 22.4025C15.0003 22.512 15.0003 22.6223 14.9898 22.7318C16.4676 22.2296 17.7585 21.2913 18.6922 20.0406C19.626 18.7899 20.1588 17.2856 20.2203 15.726C20.518 12.15 18.5568 9.05775 17.2503 7.425"
        stroke="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
